import { createSelector } from 'reselect';
import { basketSaveForLaterSelector } from 'selectors/testTarget/offers/basketSaveForLater/basketSaveForLaterSelector';

const showSelector = createSelector(basketSaveForLaterSelector, basketSaveForLater => !!basketSaveForLater.show);

export { showSelector };
